import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const AboutUsImage = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "aboutus.jpeg" }) {
        childImageSharp {
          fixed(quality: 80, width: 720, height: 500) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <Img
      style={{ height: "100%" }}
      fluid={data.placeholderImage.childImageSharp.fixed}
    />
  )
}

export default AboutUsImage
